import { render, staticRenderFns } from "./PaginaAltreScritture.vue?vue&type=template&id=d5574d9e"
import script from "./PaginaAltreScritture.vue?vue&type=script&lang=js"
export * from "./PaginaAltreScritture.vue?vue&type=script&lang=js"
import style0 from "./PaginaAltreScritture.vue?vue&type=style&index=0&id=d5574d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports